import { Container, Pagination, Stack, TextField } from "@mui/material";
import { ChangeEvent, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import useGetUsers from "./hooks/useGetUsers";
import styles from "./styles/UserData.module.css";

const UserDataPage = () => {
	const location = useLocation();
	const [currentPage, setCurrentPage] = useState<number>(0);
	const history = useHistory();
	const {
		data: usersData,
		fetchNextPage,
		isLoading,
		isFetching,
	} = useGetUsers();

	const user = useMemo<string>(() => {
		return new URLSearchParams(location.search).get("query") || "";
	}, [location.search]);

	function handleInputChange(
		e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
	) {
		const params = new URLSearchParams({ query: e.target.value });
		history.replace({
			pathname: location.pathname,
			search: params.toString(),
		});
	}

	function handlePageChange(e: ChangeEvent<unknown>, pageNo: number) {
		fetchNextPage({ pageParam: pageNo - 1 });
		setCurrentPage(pageNo - 1);
	}

	function handleUserDataClick(id: string) {
		history.push("/get-user-data/" + id);
	}
	return (
		<Container
			maxWidth="md"
			sx={{
				py: 2,
				height: "100vh",
				backgroundColor: "#f5f5f5",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<div>
				<TextField
					id="outlined-basic"
					label="Users"
					variant="outlined"
					sx={{
						width: "100%",
					}}
					value={user}
					onChange={handleInputChange}
				/>
			</div>
			<Stack
				sx={{
					flexGrow: 1,
					overflowY: "scroll",
				}}
			>
				{!isFetching &&
					!isLoading &&
					usersData?.pages[currentPage] &&
					usersData?.pages[currentPage].data.users.map((val) => (
						<button
							onClick={() => handleUserDataClick(val._id)}
							className={`${styles.userDataCard}`}
							key={val._id}
						>
							{
								<>
									<span>
										{(val?.firstName || "") +
											(val?.lastName || "")}
									</span>{" "}
									<span style={{ color: "blue" }}>
										({val.email})
									</span>
								</>
							}
						</button>
					))}
			</Stack>
			<div
				style={{
					display: "flex",
					justifyContent: "center",
				}}
			>
				<Pagination count={10} onChange={handlePageChange} />
			</div>
		</Container>
	);
};

export default UserDataPage;
